// 百度 echart
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const setOpt = options => options;
const noop = () => {};

export default class Chart extends PureComponent {
  componentDidMount() {
    const { option, addOnOption, triggerEvent, callback } = this.props;
    const chart = window.echarts.init(this.chart);
    const setOption = addOnOption(option, window.echarts, chart);
    if (typeof setOption.then === 'function') {
      setOption.then(data => {
        chart.setOption(data);
      });
    } else {
      chart.setOption(setOption);
    }
    chart.on('click', param => {
      triggerEvent(param);
    });
    callback(chart, window.echarts);
    this.myChart = chart;
  }

  render() {
    const {
      option,
      addOnOption,
      triggerEvent,
      callback,
      ...props
    } = this.props;
    return (
      <div className="echart-box" {...props}>
        <div
          className="echart"
          ref={chart => {
            this.chart = chart;
          }}
        />
      </div>
    );
  }
}

Chart.propTypes = {
  option: PropTypes.object.isRequired,
  addOnOption: PropTypes.func,
  triggerEvent: PropTypes.func,
  callback: PropTypes.func,
};

Chart.defaultProps = {
  addOnOption: setOpt,
  triggerEvent: noop,
  callback: noop,
};
